import { ArrowKinds } from "../../drawing";

export interface IArrowDrawable {
  arrowKind: ArrowKinds;
}

export function instanceOfIArrowDrawable(instance: any): instance is IArrowDrawable {
  return instance
    && (instance.arrowKind !== undefined);
}
